import Phone from '#metatypes/phone.js'
import PowerBool from '#metatypes/power_bool.js'
import PowerDate from '#metatypes/power_date.js'
import { createEnum } from '#metatypes/enum.js'
import { define, type, auto, Record, Collection } from 'type-r'
import { Email } from 'type-r/ext-types'
import Address from './address'
import { TypeIncidentInfo } from './type_incident_info'
import { IncidentInfo } from './incident_info'
import { FamilyHistoryCollection } from './family_history'
import ValidRecord from './valid_record'
import DOB from '#metatypes/dob.js'
import axios from 'axios'

@define 
export default class PatientForm extends ValidRecord {
    @(type(String).required.as) name: string
    @(type(DOB).required.as) dateOfBirth: string
    @(type(Address).as) mailingAddress: Address
    @(type(Phone).required.as) cellPhone: string
    @(type(Phone).as) homePhone: string
    @(type(Email).required.as) email: string
    @(type(String).required.as) primaryCareDoctor: string
    @(type(String).required.as) referringDoctor: string
    @(type(String).required.as) preferredPharmacy: string
    @(type(String).required.as) preferredPharmacyLocation: string
    @(type(createEnum("Glasses", "Contact Lenses", "Neither")).required.as) currentlyWear: string
    @(type(PowerBool).as) eyeMedications: boolean
    @(type(TypeIncidentInfo).as) rightEye: TypeIncidentInfo
    @(type(TypeIncidentInfo).as) leftEye: TypeIncidentInfo
    @(type(String).required.as) height: string
    @(type(String).required.as) weight: string
    @(type(IncidentInfo).as) heartAttack: IncidentInfo
    @(type(PowerBool).as) coronaryArteryDisease: boolean
    @(type(IncidentInfo).as) angina: IncidentInfo    
    @(type(IncidentInfo).as) chestPain: IncidentInfo
    @(type(IncidentInfo).as) irregularHeartRate: IncidentInfo
    @(type(IncidentInfo).as) palpitations: IncidentInfo    
    @(type(PowerBool).as) congenitalHeartDisease: boolean
    @(type(PowerBool).as) rheumatoidHeartDisease: boolean
    @(type(IncidentInfo).as) murmur: IncidentInfo
    @(type(String).value("").as) cardioExplanation: string
    @(type(PowerBool).as) respiratoryDisease: boolean
    @(type(IncidentInfo).as) stroke: IncidentInfo
    @(type(TypeIncidentInfo).as) heartSurgery: TypeIncidentInfo
    @(type(IncidentInfo).as) pacemaker: IncidentInfo
    @(type(IncidentInfo).as) aicd: IncidentInfo
    @(type(PowerBool).as) highBloodPressure: boolean
    @(type(PowerBool).as) sleepApnea: boolean
    @(type(PowerBool).as) anesthesiaDifficulty: boolean
    @(type(PowerBool).as) bleedingDisorder: boolean
    @(type(PowerBool).as) liverDisease: boolean
    @(type(PowerBool).as) kidneyDisease: boolean
    @(type(PowerBool).as) dialysis: boolean
    @(type(PowerBool).as) diabetes: boolean
    @(type(PowerBool).as) thyroidDisease: boolean
    @(type(PowerBool).as) cancer: boolean
    @(type(PowerBool).as) bigbmi: boolean
    @(type(String).value("").as) otherExplanation: string    
    @(type(PowerBool).as) medicationAllergies: boolean
    @(type(PowerBool).as) latexAllergy: boolean
    @(type(String).as) medicationListText: string
    @(type(null).as) medicationListFile: File
    @(type(String).value('text').as) medicationListUploadType: string
    // checkboxes begin - no required needed
    @(type(Boolean).as) heart: boolean
    @(type(Boolean).as) respiratory: boolean
    @(type(Boolean).as) earNoseThroat: boolean
    @(type(Boolean).as) gastrointestinal: boolean
    @(type(Boolean).as) urinary: boolean
    @(type(Boolean).as) hematologicLymphatic: boolean
    @(type(Boolean).as) endocrine: boolean
    @(type(Boolean).as) integumentary: boolean
    @(type(Boolean).as) musculoskeletal: boolean
    @(type(Boolean).as) neurological: boolean    
    @(type(Boolean).as) psychiatric: boolean
    @(type(Boolean).as) allergicImmunologic: boolean
    // checkboxes end
    @(type(createEnum("Never", "Rarely", "Moderately", "Daily")).required.as) alcohol: string
    @(type(createEnum("Never", "Rarely", "Moderately", "Daily")).required.as) tobacco: string
    @(type(FamilyHistoryCollection).value([
        { relation: "Father" },
        { relation: "Mother" },
        { relation: "Sibling" }, { relation: "Sibling" },
        { relation: "Child" }, { relation: "Child" }
    ]).as) familyHistory: FamilyHistoryCollection
    @(type(null).required.as) signature: any

    toJSON(opts?) {
        let data = super.toJSON(opts);
        
        return data;
    }
}
